import { render, staticRenderFns } from "./VtSortControl.vue?vue&type=template&id=1a8cdf8e"
import script from "./VtSortControl.vue?vue&type=script&lang=js"
export * from "./VtSortControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports